module.exports = {
	"config": {
		"siteTitle": "Rebecca Goss - UX Designer",
		"siteAuthor": "Rebecca Goss",
		"siteDescription": "I&rsquo;m Rebecca and I&rsquo;m a <span className='ttl small-caps'>UX</span> designer based in London, United Kingdom.",
		"siteMetaDescription": "I'm Rebecca and I'm a UX designer based in London, United Kingdom.",
		"siteImage": "http://www.rebeccagoss.co.uk/rebecca-goss.jpg",
		"siteURL": "http://www.rebeccagoss.co.uk/",
		"googleAnalyticsId": "UA-91320747-1",
		"linkPrefix": ""
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-01-31-newsflare",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-01-31-newsflare",
				"stem": "index",
				"path": "articles/2017-01-31-newsflare/index.md"
			},
			"requirePath": "articles/2017-01-31-newsflare/index.md",
			"path": "/newsflare/",
			"data": {
				"title": "Newsflare",
				"date": "2017-01-31T21:28:03.284Z",
				"layout": "post",
				"path": "/newsflare/",
				"category": "Case Study",
				"season": "Winter 2016",
				"headerBgColor": "light-gray",
				"homeHeaderBgColor": "golden-yellow",
				"headerTextColor": "near-black",
				"description": "Newsflare are a company specialising in user generated video which they license to news organisations around the world. Users upload content to the Newsflare platform through desktop or a mobile application.",
				"image": "./newsflare-phone-header.png",
				"imageFormat": "aside",
				"readNext": "/whats-in-the-fridge/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-02-01-rapha-filters",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-02-01-rapha-filters",
				"stem": "index",
				"path": "articles/2017-02-01-rapha-filters/index.md"
			},
			"requirePath": "articles/2017-02-01-rapha-filters/index.md",
			"path": "/rapha-filters/",
			"data": {
				"title": "Rapha E-Commerce Filters",
				"date": "2016-06-26T21:28:03.284Z",
				"layout": "post",
				"path": "/rapha-filters/",
				"category": "Case Study",
				"season": "Summer 2016",
				"homeHeaderBgColor": "duck-egg-green",
				"headerBgColor": "light-gray",
				"headerTextColor": "white",
				"description": "Designing a new filter for shop and search pages on Rapha.cc, expanding on the current facets and making it clear and simple for users.",
				"image": "./Transparent-Desktop-Filter-1.png",
				"imageFormat": "center",
				"bgSize": "contain",
				"readNext": "/rapha-basket/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-02-02-rapha-basket",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-02-02-rapha-basket",
				"stem": "index",
				"path": "articles/2017-02-02-rapha-basket/index.md"
			},
			"requirePath": "articles/2017-02-02-rapha-basket/index.md",
			"path": "/rapha-basket/",
			"data": {
				"title": "Rapha Basket Summary",
				"date": "2016-02-03T21:28:03.284Z",
				"layout": "post",
				"path": "/rapha-basket/",
				"category": "Case Study",
				"season": "Spring 2016",
				"description": "Improving the basket summary page, displaying only the relevant information, highlighting bundle purchases and allowing items to be added without navigating back to the shop pages.",
				"image": "./basket-home.png",
				"homeHeaderBgColor": "light-gray\t",
				"headerBgColor": "light-gray",
				"headerTextColor": "white",
				"imageFormat": "center",
				"bgSize": "contain",
				"readNext": "/rapha-navigation/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-02-02-rapha-nav",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-02-02-rapha-nav",
				"stem": "index",
				"path": "articles/2017-02-02-rapha-nav/index.md"
			},
			"requirePath": "articles/2017-02-02-rapha-nav/index.md",
			"path": "/rapha-navigation/",
			"data": {
				"title": "Rapha Navigation",
				"date": "2016-01-31T21:28:03.284Z",
				"layout": "post",
				"path": "/rapha-navigation/",
				"category": "Case Study",
				"season": "Spring 2016",
				"description": "Looking at the information architecture of Rapha's navigation and designing a new structure which could include content and commerce.",
				"image": "./navigation-title-image.png",
				"homeHeaderBgColor": "dusky-pink",
				"headerBgColor": "light-gray",
				"headerTextColor": "white",
				"imageFormat": "center",
				"bgSize": "contain"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-05-31-bt-aem",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-05-31-bt-aem",
				"stem": "index",
				"path": "articles/2017-05-31-bt-aem/index.md"
			},
			"requirePath": "articles/2017-05-31-bt-aem/index.md",
			"path": "/aem/",
			"data": {
				"title": "BT - Adobe Experience Manager",
				"date": "2017-05-31T21:28:03.284Z",
				"layout": "post",
				"path": "/aem/",
				"category": "Case Study",
				"season": "Summer 2017",
				"headerBgColor": "light-gray",
				"homeHeaderBgColor": "white",
				"headerTextColor": "white",
				"description": "Digital transformation of the BT.com storefront using Adobe Experience Manager. A UX led project to build a component library that could facilitate all Broadband, TV and Sports sales journeys.",
				"image": "./aem-home-page-plain-1.png",
				"imageFormat": "centre",
				"bgSize": "contain"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-08-07-bt-sport",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-08-07-bt-sport",
				"stem": "index",
				"path": "articles/2017-08-07-bt-sport/index.md"
			},
			"requirePath": "articles/2017-08-07-bt-sport/index.md",
			"path": "/bt-sport/",
			"data": {
				"title": "BT Sport",
				"date": "2017-08-31T21:28:03.284Z",
				"layout": "post",
				"path": "/bt-sport/",
				"category": "Case Study",
				"season": "Summer 2017",
				"headerBgColor": "light-gray",
				"homeHeaderBgColor": "duck-egg-blue",
				"headerTextColor": "white",
				"imageFormat": "center",
				"bgSize": "contain",
				"description": "Redesigning the BT Sport sales journeys and simplifying the way users can buy a sports package.",
				"image": "./bt-sport-home.png"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-12-09-bt-order-journey",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-12-09-bt-order-journey",
				"stem": "index",
				"path": "articles/2017-12-09-bt-order-journey/index.md"
			},
			"requirePath": "articles/2017-12-09-bt-order-journey/index.md",
			"path": "/bt-oj/",
			"data": {
				"title": "BT Order Journey",
				"date": "2017-12-31T21:28:03.284Z",
				"layout": "post",
				"path": "/bt-oj/",
				"category": "Case Study",
				"season": "Winter 2017",
				"headerBgColor": "light-gray",
				"homeHeaderBgColor": "white",
				"headerTextColor": "white",
				"description": "An internal facing UX project which tackled ways of working that were deeply entrenched in remote working teams, resulting in a 40% increase in capacity for development demand tickets.",
				"image": "./oj-home.jpg",
				"imageFormat": "center",
				"bgSize": "contain"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2018-02-01-bt-mobile",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2018-02-01-bt-mobile",
				"stem": "index",
				"path": "articles/2018-02-01-bt-mobile/index.md"
			},
			"requirePath": "articles/2018-02-01-bt-mobile/index.md",
			"path": "/bt-mobile/",
			"data": {
				"title": "BT Mobile",
				"date": "2018-03-31T21:28:03.284Z",
				"layout": "post",
				"path": "/bt-mobile/",
				"category": "Case Study",
				"season": "Spring 2018",
				"headerBgColor": "light-gray",
				"homeHeaderBgColor": "dark-blue",
				"headerTextColor": "white",
				"description": "BT Mobile has been neglected and conversion is at an all time low, the rest of the core BT products have been redesigned but the journey of buying a handset and contract are now out of date.",
				"image": "./bt-mobile-home.png",
				"imageFormat": "center",
				"bgSize": "contain"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages/about/index.md"
			},
			"requirePath": "pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "About me",
				"layout": "page",
				"path": "/about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/colours",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/colours",
				"stem": "index",
				"path": "pages/colours/index.md"
			},
			"requirePath": "pages/colours/index.md",
			"path": "/colours/",
			"data": {
				"title": "Custom Colours",
				"layout": "page",
				"path": "/colours"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/contact",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/contact",
				"stem": "index",
				"path": "pages/contact/index.md"
			},
			"requirePath": "pages/contact/index.md",
			"path": "/contact/",
			"data": {
				"title": "Fancy a chat?",
				"layout": "contact",
				"path": "/contact"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/work",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/work",
				"stem": "index",
				"path": "pages/work/index.md"
			},
			"requirePath": "pages/work/index.md",
			"path": "/work/",
			"data": {
				"title": "My work",
				"layout": "page",
				"path": "/work"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0